export const getIsArchivedQuery = () => 'isArchived';
